import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, screen, spacing } from '../../../theme';

export const StyledContainer = styled.div`
  background-color: ${color('midnight_900')};
  color: ${color('text_default_inverse')};
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
`;

export const StyledFeature = styled.div`
  max-width: ${container('xl')};
  margin: 0 auto ${spacing('xl4')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  ${Heading2} {
    margin-top: 0.3em;
    margin-bottom: ${spacing('lg')};

    &::before {
      left: 0;
      transform: unset;
    }
  }

  p {
    line-height: 1.5;

    &:first-of-type {
      margin-top: 0;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  img {
    display: block;
    max-width: 20rem;
  }
`;
